module.exports = __webpack_public_path__ + "img/download-btn-13012022.98b6ca6d.svg";